import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/new-design/images/settings/lock.png'
import _imports_1 from '@/assets/new-design/images/settings/user.png'
import _imports_2 from '@/assets/new-design/images/settings/building.png'
import _imports_3 from '@/assets/new-design/images/settings/user-group.png'
import _imports_4 from '@/assets/new-design/images/settings/duplicate.png'
import _imports_5 from '@/assets/new-design/images/settings/notification.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "content-header" }, "Settings", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "content-subheader" }, "Configure your settings here", -1)
const _hoisted_3 = { class: "settings-container" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Change Password", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Modify current password", -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Account Settings", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, " Fill in the form below to get a tenant reference ", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Business Settings", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, " Fill in the form below to get a tenant reference ", -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "User Management", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, " Fill in the form below to get a tenant reference ", -1)
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Templates", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, " Fill in the form below to get a tenant reference ", -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Reminders", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, " Fill in the form below to get a tenant reference ", -1)
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 4,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Assets Manager", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Manage the application assets", -1)
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 5,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Plan Manager", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Manage the plan options", -1)
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = {
  key: 6,
  class: "col-lg-4 col-md-6 col-12"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  class: "settings-icon",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h1", { class: "settings-header" }, "Startup Guide Manager", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "settings-subheader" }, "Manage the startup guide options", -1)
const _hoisted_49 = [
  _hoisted_46,
  _hoisted_47,
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/settings/change-password'))),
            class: "settings-item d-flex flex-column justify-content-center w-100"
          }, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile/overview'))),
            class: "settings-item d-flex flex-column justify-content-center w-100"
          }, _hoisted_14)
        ]),
        (_ctx.authUser.roles[0].includes('principal'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/profile/business-details'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_19)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('principal'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/settings/users'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_24)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/settings/templates'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_29)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/settings/reminders'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_34)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/settings/assets'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_39)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push('/settings/plans'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_44)
            ]))
          : _createCommentVNode("", true),
        (_ctx.authUser.roles[0].includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/settings/startup'))),
                class: "settings-item d-flex flex-column justify-content-center w-100"
              }, _hoisted_49)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}